import { AuthType } from '@notes/webintegrations-common'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { App } from './components/App'
import { STICKY_NOTES_FRAME_ID } from './shared/elementIds'

export function render(
  // tslint:disable-next-line:no-any
  store: any,
  authType?: AuthType,
  showHeader?: boolean
): void | Element | React.Component {
  const div = document.getElementById(STICKY_NOTES_FRAME_ID)
  if (div) {
    div.style.height = '100%'
  }
  return ReactDOM.render(
    <Provider store={ store }>
      <App authType={ authType } showHeader={ showHeader } />
    </Provider>,
    div
  )
}
